import { z } from 'zod';

export enum EnvName {
  LOCAL = 'local',
  TEST = 'test',
  DEV = 'dev',
  STAGING = 'staging',
  PRODUCTION = 'prod',
}

export const envName = z.enum(EnvName).parse(process.env.ENV_NAME);

const clearEmptyString = (value: unknown) => {
  return (typeof value === 'string' && value === '') ? undefined : value;
};

export const multiModalUrl = z
  .preprocess(clearEmptyString, z.url().nullable().default(null))
  .parse(process.env.MULTIMODAL_URL);
